import { render, staticRenderFns } from "./comp_ShipmentCalculator.vue?vue&type=template&id=b36a0bc8&scoped=true&"
import script from "./comp_ShipmentCalculator.vue?vue&type=script&lang=js&"
export * from "./comp_ShipmentCalculator.vue?vue&type=script&lang=js&"
import style0 from "./comp_ShipmentCalculator.vue?vue&type=style&index=0&id=b36a0bc8&prod&lang=scss&"
import style1 from "./comp_ShipmentCalculator.vue?vue&type=style&index=1&id=b36a0bc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36a0bc8",
  null
  
)

export default component.exports